// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Jb0Id","requiredAsterisk":"Info_requiredAsterisk__KLAH-"};